<template lang="pug">
  div.unauthorized.heap-update
    e-form-modal(
      @submitModalForm="sendForm()"
      @deleteItem="deleteItem()"
      :hideDeleteButton="(!!fields.id)"
    )
      div(slot="header")
        e-breadcrumbs
        h1.title {{formTitle}}
        e-form-tabs(
          v-model="tabView"
          :tabs="tabs"
        )
      slot
        e-form(:formValidator="formValidator")
          div(v-show="tabView === 'tab1'")
            div.body
              div.col
                e-form-group(
                  name="name"
                  inputType="input"
                  label="Наименование/идентификатор"
                  :model="fields"
                  :required="true"
                  tabView="tab1"
                )
                e-form-group(
                  name="area"
                  inputType="input"
                  validationRule="double"
                  label="Площадь объекта, кв. м."
                  :model="fields"
                  tabView="tab1"
                )
                e-form-group(
                  name="_cadastralCode"
                  inputType="input"
                  label="Кадастровый номер участка"
                  :model="fields"
                  tabView="tab1"
                )
                e-form-group(
                  name="year_detection"
                  inputType="select"
                  :options="years"
                  label="Год обнаружения"
                  :model="fields"
                  tabView="tab1"
                  :required="true"
                )
                e-form-group(
                  name="geo_object_id"
                  inputType="select"
                  label="Ответственный за ликвидацию"
                  :model="fields"
                  :options="regionalOperators"
                  placeholder="Выберите ответственного"
                  tabView="tab1"
                )
              
              div.col
                e-form-group(
                  name="status_id"
                  inputType="select"
                  :required="true"
                  label="Статус объекта"
                  :model="fields"
                  tabView="tab1"
                  :options="statuses"
                )
                e-form-group(
                  name="capacity"
                  inputType="input"
                  label="Объем, куб.м."
                  :model="fields"
                  validationRule="double"
                  tabView="tab1"
                )
                e-form-group(
                  name="description"
                  inputType="textarea"
                  label="Описание"
                  :model="fields"
                  tabView="tab1"
                )
                e-form-group(
                  name="year_liquidation"
                  inputType="select"
                  :options="years"
                  label="Год ликвидации"
                  :disabled="fields.status_id != notActive"
                  :model="fields"
                  tabView="tab1"
                )
              
              div.col
                e-location(
                  :formValidator="formValidator"
                  :model="fields"
                  name="address"
                  :required="true"
                  :addressData="addressData"
                  :geoFields="['lat', 'lon']"
                  tabView="tab1"
                )
                e-form-group(
                  name="orientation"
                  inputType="input"
                  label="Ориентир"
                  :model="fields"
                  tabView="tab1"
                )
              div.col
                e-form-group(
                  name="photoPreview"
                  inputType="simple-file-uploader"
                  label="Фотография"
                  :model="fields"
                  tabView="tab1"
                  :uploadUrl="uploadUrl"
                  @fileUploaded="fileUploaded"
                  @fileRemoved="fileRemoved"
                  :showFilePreview="true"
                )
          
          //Журнал изменений
          div(v-show="tabView === 'tab2'")
            change-log-tab(
              :entityId="fields.id"
              :moduleId="moduleId"
            )
          //Документы
          div(v-show="tabView === 'tab3'")
            documents-table(
              :document-ids="documentIds"
              @documentsChanged="documentsChanged"
            )
</template>

<script>
  import { atu, unauthorized } from '@/api/api-endpoints'
  import unauthorizedForm      from './mixins/unauthorized-form.js'
  import DocumentsTable        from '@/common/layout/documents/DocumentsTable'
  
  export default {
    name:       'HeapUpdate',
    mixins:     [unauthorizedForm],
    components: {
      DocumentsTable
    },
    data() {
      return {
        tabView: 'tab1',
        fields:  {
          name:             '',
          status_id:        '',
          latitude:         '',
          longitude:        '',
          _cadastralCode:   '',
          lat:              '',
          lon:              '',
          year_detection:   '',
          year_liquidation: ''
        },
        errors:  null
      }
    },
    computed: {
      formTitle() {
        if (this.fields && this.fields.id) {
          return this.fields.name
        }
        return this.$translate('Добавление несанкционированной свалки')
      },
      moduleId() {
        return this.moduleIds['unauth-heap']
      },
      tabs() {
        const tabs = [{ tab1: 'Общие сведения' }]
        if (this.fields.id) {
          tabs.push({ tab2: 'Журнал изменений' })
        }
        tabs.push({ tab3: 'Документы' })
        return tabs
      }
    },
    methods:  {
      getRegionalOperatorEndpoint() {
        return atu.tkoOperators()
      },
      getDeleteUrl(id) {
        return unauthorized.heapDelete(id)
      },
      getUpdateOrCreateUrl() {
        return unauthorized.heapUpdateOrCreate(this.$route.params.id)
      },
      getItemEndpoint(route) {
        if (!route.params.id) {
          return null
        }
        return unauthorized.heap(route.params.id)
      }
    }
  }
</script>
